// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attachFilesModal__fuPYY {
  width: 700px;
  min-height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media (max-width: 701px) {
  .attachFilesModal__fuPYY {
    width: 100%;
  }
}

.modalBody__QWJym {
  flex: 1;
  padding: 0 25px;
}

.dropzoneWrapper__ncjMU {
  width: 100%;
  height: 325px;
  border-radius: 2px;
  background: var(--tables-secondary-row-sub-title-surface);
  border-radius: 5px;
  position: relative;
  overflow-y: auto;
}
.dropzoneWrapper__ncjMU::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.dropzoneWrapper__ncjMU::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.dropzoneWrapper__ncjMU::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.dropzoneWrapper__ncjMU::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.modalFooter__Ll5dY {
  padding: 25px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AttachFilesModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;AA2EE;EAPF;IAQI,WAAA;EAxEF;AACF;;AA2EA;EACE,OAAA;EACA,eAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yDAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAxEF;AAAE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAEJ;AACE;EACE,+BAAA;EACA,kBAAA;AACJ;AAEE;EACE,8BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,kBAAA;AADJ;;AA4DA;EACE,aAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AAzDF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.attachFilesModal {\n  width: 700px;\n  min-height: 480px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  @media (max-width: 701px) {\n    width: 100%;\n  }\n}\n\n.modalBody {\n  flex: 1;\n  padding: 0 25px;\n}\n\n.dropzoneWrapper {\n  width: 100%;\n  height: 325px;\n  border-radius: 2px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 5px;\n  position: relative;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.modalFooter {\n  padding: 25px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"attachFilesModal": `attachFilesModal__fuPYY`,
	"modalBody": `modalBody__QWJym`,
	"dropzoneWrapper": `dropzoneWrapper__ncjMU`,
	"modalFooter": `modalFooter__Ll5dY`
};
module.exports = ___CSS_LOADER_EXPORT___;
